//  Purposes from https://vendor-list.consensu.org/v3/vendor-list.json
export const Store_and_or_access_information_on_a_device = 1;
export const Use_limited_data_to_select_advertising = 2;
export const Create_profiles_for_personalised_advertising = 3;
export const Use_profiles_to_select_personalised_advertising = 4;
export const Create_profiles_to_personalise_content = 5;
export const Use_profiles_to_select_personalised_content = 6;
export const Measure_advertising_performance = 7;
export const Measure_content_performance = 8;
export const Understand_audiences_through_statistics_or_combinations_of_data_from_different_sources = 9;
export const Develop_and_improve_services = 10;
export const Use_limited_data_to_select_content = 11;

export const Required_Purposes: number[] = [
	Store_and_or_access_information_on_a_device,
	Use_limited_data_to_select_advertising,
	Create_profiles_for_personalised_advertising,
	Use_profiles_to_select_personalised_advertising,
	Measure_advertising_performance,
	Understand_audiences_through_statistics_or_combinations_of_data_from_different_sources,
];

//VENDORS from https://vendor-list.consensu.org/v3/vendor-list.json
export const Amazon_Vendor = 793;
export const Blockthrough_Vendor = 815;
export const Criteo_SA = 91;
export const GumGum_Inc = 61;
export const Improve_Digital = 253;
export const Index_Exchange_Inc = 10;
export const LiveRamp_Vendor = 97;
export const Magnite_Inc = 52;
export const Rich_Audience_Technologies_SLU = 108;
export const SPORTORITY_UK_LTD = 918; //minutemedia
export const Taboola_Europe_Limited = 42;
export const The_Ozone_Project_Limited = 524;
export const Triple_Lift_Inc = 28;
export const Xandr_Inc = 32;

export const Magnite_Vendors = [Magnite_Inc, Xandr_Inc, Triple_Lift_Inc];
export const Prebid_Vendors = [
	Criteo_SA,
	GumGum_Inc,
	Improve_Digital,
	Index_Exchange_Inc,
	Rich_Audience_Technologies_SLU,
	SPORTORITY_UK_LTD,
	Taboola_Europe_Limited,
	The_Ozone_Project_Limited,
	Xandr_Inc,
];
